import React, { memo, useCallback } from 'react'
import { parseIncompletePhoneNumber } from 'libphonenumber-js/mobile'

import Input from '../../Input'
import { RegField } from '../types'
import { formatIncompletePhoneNumber } from 'libphonenumber-js'

interface PhoneInputProps {
  phoneNumber?: string
  error?: string | React.ReactElement
  disabled?: boolean
  onChange: (key: keyof RegField, value: RegField[typeof key]) => void
  onValidate: (...keys: ['clean_phone']) => () => void
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  phoneNumber,
  error,
  disabled,
  onChange,
  onValidate,
}) => {
  const valuePhone = phoneNumber
    ? formatIncompletePhoneNumber(phoneNumber, {
        defaultCountry: undefined,
        defaultCallingCode: undefined,
      })
    : phoneNumber

  const handlePhoneChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let { value } = e.target
      if (!value.startsWith('+')) {
        value = `+${value}`
      }
      if (value.length > 16) return
      onChange('clean_phone', parseIncompletePhoneNumber(value))
      onValidate('clean_phone')()
    },
    [onChange, onValidate],
  )

  const handleSetDefaultValue = useCallback(() => {
    if (valuePhone && valuePhone !== '+') return
    onChange('clean_phone', '+7 ')
  }, [onChange, valuePhone])

  return (
    <Input
      type="tel"
      disabled={disabled}
      placeholder="+7 XXX XXX XX XX"
      // data-i18n-placeholder="hero.placeholders.phone"
      className="input"
      value={valuePhone}
      errorMsg={error}
      inputMode="numeric"
      onFocus={handleSetDefaultValue}
      onBlur={onValidate('clean_phone')}
      onChange={handlePhoneChange}
    />
  )
}

export default memo(PhoneInput)
